import React from "react";
import _ from "lodash";

import Button from "./base/Button";
import uiPrefix from "../utils/UiPrefixUtils";

class ErrorSaving extends React.Component {
  _reload = () => {
    location.reload(true);
  };

  render() {
    const style = {
      position: "absolute",
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "center",
      WebkitAlignItems: "center",
      WebkitJustifyContent: "center",
      backgroundColor: "rgba(0,0,0,.9)",
      zIndex: 50000,
    };

    const { error } = this.props;

    let message = _.get(error, "message", "Error");
    const code = _.get(error, "status");
    const displayMessage =
      code === 413 // Payload Too Large
        ? "Your site is too large to save. Please remove some content and try again. To minimize data loss, please refresh your browser."
        : "We're having trouble auto-saving your site. To minimize data loss, please refresh your browser.";

    if (!_.isString(message)) {
      try {
        message = JSON.stringify(error);
      } catch (e) {
        message = "Critical Error";
      }
    }

    return (
      <div style={style}>
        <h1>Oh dear...</h1>
        <p> {displayMessage} </p>
        <Button
          look="primary"
          data-e2e={uiPrefix("modal-refresh-btn")}
          className={uiPrefix("modal-refresh-btn")}
          onClick={this._reload}
        >
          Refresh
        </Button>
        <div style={{ position: "absolute", bottom: 4, left: 4, fontSize: 10 }}>
          <div>{message}</div>
        </div>
      </div>
    );
  }
}

export default ErrorSaving;
